import React, { useEffect} from 'react'
import {Link, useHistory} from 'react-router-dom'
import {  fetchCustomerConversationsStart } from './../redux/Conversations/conversations.actions';
import { useDispatch, useSelector } from 'react-redux';
import Button from './../components/forms/Button'
import DashAuthWrapper from './../components/DashAuthWrapper'
import {format} from 'date-fns'

const mapState = ({ user, conversationsData }) => ({
	currentUser: user.currentUser,
	conversations: conversationsData.conversations
	
})

const Conversations = props => {
	const { currentUser, conversations } = useSelector(mapState);
	const dispatch = useDispatch();
	const history = useHistory();

	const { data2 } = conversations;

	useEffect(() => {
		dispatch(
			fetchCustomerConversationsStart()
		);
		window.scrollTo(0, 0)
		// eslint-disable-next-line
	}, []);


	//create and filter conversation array
	const convoByService = [];
	if(Array.isArray(data2)){
		for(let i = 0; i < data2.length; i++){
			if(data2[i].custsID === `${currentUser.id}`&& data2[i].userRoles === `customer`){
				convoByService.push(data2[i]);
			}
		}
	}


	const congfigAuthWrapper = {
		headline: 'Conversations'
	}

	return (
		<div className="pb-10 mb-10">
			{!currentUser.subscribed &&(
				<DashAuthWrapper>
					<h3 className="mt-5">You currently have no subscription</h3>
				
					<h3>Please 
						<Link to="/services">
							<Button>
								SUBSCRIBE
							</Button>
						</Link>
						to be eligible for services
					</h3>
				</DashAuthWrapper>
			)}

			{currentUser.subscribed &&(
				<DashAuthWrapper {...congfigAuthWrapper}>
		
				{convoByService[0] ?(
					<div className="cart">
						<table border="0" cellPadding="0" cellSpacing="0">
							<tbody>
								<tr>
									<td>
										<table className="convoHeader" border="0" cellPadding="10" cellSpacing="0">
											<tbody >
											<tr >
												<th >
													Service
												</th>
												<th >
													Date
												</th>
												<th >
													
												</th>
											</tr>
											</tbody>
										</table>
									</td>
								</tr>
								<tr> 
									<td>
										<table className="convoResults" border="0" cellPadding="10" cellSpacing="0">
										<tbody>
										
											{convoByService.map((convo, index) => {
											const {
												serviceName,
												createdDate,
												vendorsID
											} = convo;
											
											return (
												<tr key={index}>
												
												<td>{serviceName}</td>
												<td>
													{format(createdDate.toDate(), 'MMM dd, yyyy ')}
												</td>
												<td className="text-right">
													<button className="btn" onClick={() => history.push(`/conversation/${serviceName}/${vendorsID}`)}>Chat</button>
												</td>
												
												</tr>
											)})}
										
		
										</tbody>
										</table>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				):(
					<div>
						<h5>Currently no Conversations</h5>
					</div>
				)}

	
			
			</DashAuthWrapper>
			)}
		</div>	




		
	)
}

export default Conversations;